export const CREATE = 'CREATE';
export const DELETE = 'DELETE';
export const FETCH_ALL = 'FETCH_ALL';
export const UPDATE = 'UPDATE';
